
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class DayHeadCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource

  handleClick() {
    if (this.dataSource.event) {
      this.onClickEvent(this.dataSource.event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
